// extracted by mini-css-extract-plugin
export default {"priceListMtr":"PriceListMtr_priceListMtr__7Xpcs","wrapperMenu":"PriceListMtr_wrapperMenu__gd1h6"};